import React from "react";

// LOAD ALL FACULTY IMAGES
const facultyImages = require.context(
  "../assets/faculty",
  false,
  /\.(png|jpe?g|svg)$/
);

// CREATE IMAGE MAP
const imageMap = facultyImages.keys().reduce((acc, item) => {
  const fileName = item.replace("./", "").replace(/\.(png|jpe?g|svg)$/i, "");
  acc[fileName] = facultyImages(item);
  return acc;
}, {});

function Faculty() {

  const faculty = [
    { id: 1, name: "R. Venkata Reddy", qualification: "M.Com., M.F.M, B.LiSc, APSET" },
    { id: 2, name: "S. Manohar Reddy", qualification: "M.A., B.Ed" },
    { id: 3, name: "A. Harinath", qualification: "M.Com" },
    { id: 4, name: "Anjineyulu", qualification: "M.A., TPT" },
    { id: 5, name: "B. Ramesh Naik", qualification: "M.A., M.Sc Zoology., B.Ed" },
    { id: 6, name: "S. Thasleem", qualification: "M.Sc Botany., B.Ed" },
    { id: 7, name: "D. Chandrasekhar", qualification: "M.Sc Chemistry., B.Ed" },
    { id: 8, name: "P. Pramod", qualification: "M.Sc Physics., B.Ed" },
    { id: 9, name: "P. Chandrasekhar", qualification: "M.Com., M.F.M., APSET" },
    { id: 10, name: "C. Balakrishna", qualification: "M.Sc Computers" },
    { id: 11, name: "K. Sumalatha", qualification: "M.Sc Maths., B.Ed" },
    { id: 12, name: "S. Gousiya", qualification: "M.A." },
    { id: 13, name: "N. Gangadhar", qualification: "M.A., B.Ed" },
    { id: 14, name: "G. Ganesh", qualification: "M.Sc Computers" },
    { id: 15, name: "T. Ramanjineyulu", qualification: "M.A., B.Ed" },
    { id: 16, name: "K. Vineetha", qualification: "M.Sc Maths., B.Ed" },
    { id: 17, name: "G. Raghavendra Reddy", qualification: "M.P.Ed" },
    { id: 18, name: "P. Maeen Basha", qualification: "M.A." },
    { id: 19, name: "D.V. Prahallada", qualification: "B.A., Senior Assistant" },
    { id: 20, name: "K. Somusekhar", qualification: "MCA" }
  ];

  return (
    <div className="page">
      <h1 className="page-title">Our Faculty</h1>

      <div className="faculty-grid">
        {faculty.map((f) => (
          <div className="faculty-card" key={f.id}>

            {/* <img
              src={imageMap[f.name] || "/default-profile.jpeg"}
              alt={f.name}
            /> */}

            {imageMap[f.name] ? (
              <img
                src={imageMap[f.name]}
                alt={f.name}
              />
            ) : (
              <div
                style={{
                  width: "180px",
                  height: "220px",
                  background: "#fff",
                  borderRadius: "12px",
                  margin: "20px auto"
                }}
              />
            )}

            <h3>{f.name}</h3>

            <p className="designation">
              {f.qualification}
            </p>

          </div>
        ))}
      </div>
    </div>
  );
}

export default Faculty;